import React, { type ReactNode } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';

type Props = {
	fallback: 'flag' | 'unmount';
	eventLocation: string;
	children: ReactNode;
	onError?: (location: string, error: Error) => void;
};

// Wrap the non-critical component where you expect errors are thrown in case you don't want to blow up the whole page
// When 'flag' is given, it will display a generic error message to encourage user to refresh. You can't customize message to display
export const NonCriticalErrorBoundary = ({ fallback, eventLocation, children, onError }: Props) => (
	<JSErrorBoundary
		fallback={fallback}
		packageName="jiraSoftwareReleasesVersionDetail"
		teamName="fusion-solaris"
		id={eventLocation}
		onError={onError}
	>
		{children}
	</JSErrorBoundary>
);
